import { render } from "./UserDetails.vue?vue&type=template&id=da1a6ff6&scoped=true&ts=true"
import script from "./UserDetails.vue?vue&type=script&lang=ts"
export * from "./UserDetails.vue?vue&type=script&lang=ts"

import "./UserDetails.vue?vue&type=style&index=0&id=da1a6ff6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da1a6ff6"]])

export default __exports__